
import collapseTransition from "@/library/collapse-transition.js"
function debounce(fn, delay) {
  let timer = null
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}

let timer = null

export default {
  name: "SearchInput",
  components: { collapseTransition },
  props: {
    historySearch: {
      type: Array,
      default: () => []
    },
    hotKeywords: {
      type: Array,
      default: () => []
    },
    keywords: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    suggestions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      focus: false,
      hasInput: false,
      hasChanged: false,
      historySearchData: [],
      suggestionsData: [],
      inputStr: "",
      showResults: ""
    }
  },
  computed: {
    placeholderD() {
      return this.placeholder
    }
  },

  watch: {
    keywords: {
      handler(val, old) {
        this.inputStr = val
        // if(val){
        //   this.handleSearch(val)
        // }
      },
      immediate: true
    },
    inputStr: {
      handler(val, old) {
        this.hasInput = !!val
        this.suggestionsData = []
        this.hasChanged = !!(val && old !== val)
      },
      immediate: true
    },
    suggestions: {
      handler(val, old) {
        this.suggestionsData = val
      },
      immediate: true
    },
    $route(to, from) {
      // 监听路由变化
      if (to.path !== "/zh-hant/search" && to.path !== "/en/search") {
        this.handleClearInput()
      }
    }
  },
  created() {},
  mounted() {
    this.$bus.$on("wareCountChange", this.showResultsFun)
  },
  beforeDestroy() {
    this.$bus.$off("wareCountChange")
  },
  methods: {
    handlePopClick() {
      clearTimeout(timer)
      this.$refs.input.focus()
    },
    translate(name) {
      return this.$t(name)
    },
    handleFocus() {
      this.focus = true
      this.hasChanged = false
      this.$emit("focus", this.inputStr)
    },
    handleBlur() {
      timer = setTimeout(() => {
        this.focus = false
      }, 100)
      this.$emit("blur")
    },

    handleInput: debounce(function () {
      this.$emit("input", this.inputStr)
    }, 300),

    handleSearch() {
      if (this.inputStr) {
        this.$emit("search", this.inputStr)
      }
    },
    handleClearRecentlySearch() {
      this.$emit("clearRecentlySearch")
    },

    handleHotKeywordsClick(data) {
      this.inputStr = data.word

      this.focus = false
      this.$emit("hotKeywordsClick", data)
    },
    handleClearInput() {
      this.inputStr = ""
      this.focus = false
      this.showResults = ""
      this.$emit("clearInput")
    },
    handleEnter() {
      if (this.inputStr) {
        this.$emit("keyupEnter", this.inputStr)
      }
    },
    handleHistoryClick(data) {
      this.inputStr = data
      this.focus = false
      this.$emit("historyClick", data)
    },
    handleSuggestionsClick(data) {
      this.inputStr = data.suggestedKeyword
      this.focus = false
      this.$emit("suggestionsClick", data)
    },
    showResultsFun(obj) {
      const isSearchResult = window.location.href.includes("search")
      this.showResults =
        isSearchResult && !obj.noResult ? this.$t("common.searchResults", { searchResult: obj.count }) : ""
    }
  }
}
